import { render, staticRenderFns } from "./HistoryOrders.vue?vue&type=template&id=4b73a596&scoped=true&"
import script from "./HistoryOrders.vue?vue&type=script&lang=js&"
export * from "./HistoryOrders.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrders.vue?vue&type=style&index=0&id=4b73a596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73a596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
